// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2992":"c20eb223","5112":"9bd64952","5528":"9bd64952"}[chunkId] + ".css";
};